import angular from 'angular';
import ngMessages from 'angular-messages';
import moment from 'moment';
import ngTranslate from 'angular-translate';
import 'angular-translate-loader-static-files';
import TkrSpaCommon from '../../../common/tkr-spa';
import TkrAppConfig from '../../../common/TkrAppConfig';
import { TkrPersonService } from '../../../common/tkr-commonservices';
import { IbanService, IbanValidator } from '../../../common/ma-iban';
import { SmartFloat, SmartInteger } from '../../../common/ma-smartfloat-1.0';
import TkrPpCommon from '../../../pp/common/0-pp-common-module';
import TkrPpResources from '../../../pp/prcportal-resource-modules';
import { configureTranslateProvider } from '../../../pp/translation-helpers';
const subsidy_application_app = angular.module('ng-tkr-app-sastamalayhdkohde', [
    TkrSpaCommon,
    TkrAppConfig,
    ngMessages,
    ngTranslate,
    TkrPersonService,
    IbanValidator,
    IbanService,
    SmartFloat,
    SmartInteger,
    TkrPpResources,
    TkrPpCommon,
])
    .config(config)
    .config(configureTranslateProvider);
export default subsidy_application_app.name;
config.$inject = ['$stateProvider', '$urlRouterProvider'];
function config($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise('/err');
    $stateProvider
        .state('err', {
        url: '/err',
        template: '<p class="h4 text-danger">Sisäinen virhe. Ota yhteyttä helpdesk@matriset.fi.</p>'
    })
        .state('root', {
        url: '',
        template: '',
        controller: 'AppRedirCtrl',
        controllerAs: 'vm'
    })
        .state('lomake', {
        url: '/:applicationId',
        template: require('./kohde-app.tpl.html'),
        controller: 'SubsidyApplicationController',
        controllerAs: 'vm',
        resolve: {
            app: ['PortalSubsidyAppService', '$stateParams', function (PortalSubsidyAppService, $stateParams) {
                    return PortalSubsidyAppService.get({ appId: $stateParams.applicationId }).$promise;
                }],
            appPeriod: ['PortalAppPeriodService', 'app', function (PortalAppPeriodService, app) {
                    return PortalAppPeriodService.get({ periodId: app.applicationPeriodId }).$promise;
                }]
        }
    })
        .state('jatetty', {
        url: '/:applicationId/jatetty',
        template: require('./kohde-submitted.tpl.html'),
        controller: 'AppSubmittedController',
        controllerAs: 'vm'
    });
}
subsidy_application_app.controller('SubsidyApplicationController', SubsidyApplicationController);
SubsidyApplicationController.$inject = [
    '$scope',
    'app',
    'appPeriod',
    'TkrPersonService',
    '$state',
];
function SubsidyApplicationController($scope, app, appPeriod, TkrPersonService, $state) {
    var vm = this;
    vm.app = app;
    vm.vuosi = appPeriod.td.wnum.vuosi;
    vm.edvuosi = vm.vuosi - 1;
    vm.loppuAika = moment(appPeriod.end).local().format('D.M.YYYY HH:mm');
    vm.periodName = appPeriod.name;
    vm.personRoles = TkrPersonService.personRoles;
    vm.chairmanRoles = TkrPersonService.chairmanRoles;
    vm.preprocessApp = function (data) {
        if (!data.chairman) {
            data.chairman = {};
        }
        if (!data.contactPerson) {
            data.contactPerson = {};
        }
        if (!data.td) {
            data.td = {};
        }
        if (!data.td.num) {
            data.td.num = {};
        }
        if (!data.td.wnum) {
            data.td.wnum = {};
        }
    };
    vm.preprocessApp(vm.app);
    $scope.$watch('app.contactPerson.role', function (newValue, oldValue) {
        $scope.contactIsChairman = TkrPersonService.isValidChairmanRole(newValue);
    });
    $scope.$watch('contactIsChairman', function (newValue, oldValue) {
        if (!newValue) {
            if ($scope.old_chairman) {
                vm.app.chairman = $scope.old_chairman;
            }
        }
        else if (newValue && !oldValue) {
            $scope.old_chairman = vm.app.chairman;
            vm.app.chairman = vm.app.contactPerson;
        }
    });
    vm.isChairmanRequired = function () {
        return true;
    };
    vm.isSeparateChairmanRequired = function () {
        if (!vm.isChairmanRequired()) {
            return false;
        }
        if (!vm.app || !vm.app.contactPerson) {
            return true;
        }
        return TkrPersonService.isValidChairmanRole(vm.app.contactPerson.role) ? false : true;
    };
    vm.postprocessApp = function (data) {
        data.chairman = null;
        if (!vm.app.contactPerson.emailAddress) {
            vm.app.eDecision = false;
        }
        else if (vm.app.eDecision) {
            vm.app.eDecisionEmail = vm.app.contactPerson.emailAddress;
        }
    };
    vm.save = function () {
        vm.postprocessApp(vm.app);
        vm.app.applicationState = 'SUBMITTED';
        vm.app.$save().then(function (data) {
            $state.go('jatetty', { applicationId: data.id });
        });
    };
    vm.saveDraft = function () {
        vm.app.applicationState = 'DRAFT';
        vm.app.$save().then(function (data) {
            vm.draftSaved = true;
        });
    };
}
